// /src/state — Supabase client. All I/O lives outside engines/services (§16).
// Targets the fresh `uee` schema (never `ecommerce_growth`).
//
// Uses the ANON key only (VITE_-prefixed, client-safe). The service_role key
// must never reach the frontend.
import { createClient } from '@supabase/supabase-js';
import { normalizeUrl, describeSupabaseError } from './supabaseErrors.js';

export { describeSupabaseError };

const rawUrl = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const { baseUrl, urlError } = normalizeUrl(rawUrl);

// True only when we have a usable (normalized) URL AND a key.
export const isConfigured = Boolean(baseUrl && anonKey);

export const supabase = isConfigured
  ? createClient(baseUrl, anonKey, { db: { schema: 'uee' } })
  : null;

export function requireSupabase() {
  if (supabase) return supabase;
  // Distinguish "you gave a bad URL" from "you gave nothing".
  if (rawUrl && urlError) throw new Error(urlError);
  throw new Error(
    'Supabase not configured. Set VITE_SUPABASE_URL (base project URL) and VITE_SUPABASE_ANON_KEY.',
  );
}
